var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 45,
    viewBox: "0 0 152 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 151.875,
    height: 45,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.653 24.47C74.007 24.47 71.8504 26.4826 71.8504 29.2546C71.8504 32.0098 74.007 34.0393 76.653 34.0393C79.3001 34.0393 81.4567 32.0098 81.4567 29.2546C81.4556 26.4826 79.299 24.47 76.653 24.47ZM76.653 32.156C75.2029 32.156 73.953 30.9601 73.953 29.2558C73.953 27.5334 75.204 26.3555 76.653 26.3555C78.1031 26.3555 79.353 27.5334 79.353 29.2558C79.353 30.959 78.1031 32.156 76.653 32.156ZM66.1747 24.47C63.5287 24.47 61.3721 26.4826 61.3721 29.2546C61.3721 32.0098 63.5287 34.0393 66.1747 34.0393C68.8219 34.0393 70.9785 32.0098 70.9785 29.2546C70.9785 26.4826 68.8219 24.47 66.1747 24.47ZM66.1747 32.156C64.7246 32.156 63.4747 30.9601 63.4747 29.2558C63.4747 27.5334 64.7257 26.3555 66.1747 26.3555C67.6249 26.3555 68.8747 27.5334 68.8747 29.2558C68.8759 30.959 67.6249 32.156 66.1747 32.156ZM53.712 25.9393V27.9688H58.5697C58.4246 29.1106 58.0444 29.9443 57.4639 30.5236C56.7574 31.2301 55.6515 32.0098 53.712 32.0098C50.7217 32.0098 48.384 29.5989 48.384 26.6086C48.384 23.6184 50.7217 21.2075 53.712 21.2075C55.3252 21.2075 56.5031 21.842 57.3727 22.6576L58.8049 21.2255C57.5899 20.0656 55.9777 19.178 53.712 19.178C49.6159 19.178 46.1722 22.5125 46.1722 26.6086C46.1722 30.7048 49.6159 34.0393 53.712 34.0393C55.9226 34.0393 57.591 33.3136 58.8949 31.9546C60.2359 30.6136 60.6532 28.7281 60.6532 27.206C60.6532 26.7358 60.6172 26.3004 60.5441 25.9381H53.712V25.9393ZM104.683 27.5154C104.285 26.4466 103.07 24.47 100.587 24.47C98.1225 24.47 96.0739 26.4095 96.0739 29.2546C96.0739 31.9366 98.1045 34.0393 100.822 34.0393C103.015 34.0393 104.284 32.6983 104.811 31.9186L103.179 30.8308C102.636 31.6284 101.892 32.1538 100.822 32.1538C99.7537 32.1538 98.9921 31.6644 98.5027 30.7036L104.901 28.0576L104.683 27.5154ZM98.1585 29.1106C98.1045 27.2611 99.5906 26.3195 100.66 26.3195C101.494 26.3195 102.201 26.7369 102.437 27.3343L98.1585 29.1106ZM92.9576 33.7501H95.0591V19.6865H92.9576V33.7501ZM89.5129 25.5399H89.4409C88.9695 24.9774 88.0627 24.47 86.922 24.47C84.5291 24.47 82.3365 26.5726 82.3365 29.2738C82.3365 31.9558 84.5291 34.0404 86.922 34.0404C88.0639 34.0404 88.9695 33.533 89.4409 32.9536H89.5129V33.6421C89.5129 35.4725 88.5341 36.4513 86.958 36.4513C85.671 36.4513 84.8734 35.5276 84.5471 34.748L82.7167 35.5096C83.2421 36.7775 84.6371 38.3368 86.958 38.3368C89.4229 38.3368 91.5075 36.8866 91.5075 33.3519V24.7614H89.514V25.5399H89.5129ZM87.1031 32.156C85.653 32.156 84.4391 30.941 84.4391 29.2738C84.4391 27.5874 85.653 26.3555 87.1031 26.3555C88.5341 26.3555 89.658 27.5874 89.658 29.2738C89.658 30.941 88.5341 32.156 87.1031 32.156ZM114.532 19.6865H109.502V33.7501H111.6V28.4221H114.531C116.857 28.4221 119.145 26.738 119.145 24.0549C119.145 21.3718 116.858 19.6865 114.532 19.6865ZM114.586 26.4646H111.6V21.644H114.586C116.155 21.644 117.046 22.9434 117.046 24.0549C117.046 25.1439 116.155 26.4646 114.586 26.4646ZM127.559 24.4453C126.039 24.4453 124.465 25.1146 123.814 26.5985L125.677 27.3759C126.075 26.5985 126.818 26.3443 127.595 26.3443C128.681 26.3443 129.784 26.9956 129.802 28.1533V28.2984C129.422 28.0813 128.608 27.7561 127.613 27.7561C125.605 27.7561 123.56 28.8598 123.56 30.9219C123.56 32.804 125.207 34.0156 127.052 34.0156C128.463 34.0156 129.241 33.3823 129.729 32.6398H129.801V33.7254H131.829V28.3333C131.83 25.838 129.964 24.4453 127.559 24.4453ZM127.305 32.1526C126.619 32.1526 125.659 31.8084 125.659 30.9579C125.659 29.8723 126.854 29.456 127.885 29.456C128.807 29.456 129.242 29.6551 129.802 29.9263C129.639 31.2301 128.518 32.1526 127.305 32.1526ZM139.211 24.7524L136.804 30.8499H136.732L134.235 24.7524H131.974L135.719 33.2743L133.584 38.015H135.773L141.545 24.7524H139.211ZM120.304 33.7501H122.402V19.6865H120.304V33.7501Z",
    fill: "#F4FAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3453 11.5233C53.3453 12.4661 53.0663 13.2164 52.5072 13.7767C51.8727 14.4427 51.0447 14.7757 50.0277 14.7757C49.0534 14.7757 48.2243 14.4382 47.5437 13.7632C46.8619 13.0871 46.5211 12.2501 46.5211 11.2511C46.5211 10.2509 46.8619 9.41394 47.5437 8.73894C48.2243 8.06281 49.0534 7.72531 50.0277 7.72531C50.5114 7.72531 50.9738 7.81981 51.4126 8.00769C51.8524 8.19669 52.2046 8.44756 52.4678 8.76144L51.8749 9.35544C51.4283 8.82106 50.8129 8.55444 50.0266 8.55444C49.3156 8.55444 48.7013 8.80419 48.1827 9.30369C47.6641 9.80319 47.4053 10.4523 47.4053 11.2499C47.4053 12.0476 47.6641 12.6967 48.1827 13.1962C48.7013 13.6957 49.3156 13.9454 50.0266 13.9454C50.7803 13.9454 51.4092 13.6946 51.9121 13.1917C52.2383 12.8643 52.4273 12.4087 52.4779 11.8248H50.0266V11.0137H53.2969C53.3307 11.1903 53.3453 11.3602 53.3453 11.5233Z",
    fill: "#F4FAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5317 8.70412H55.4582V10.8439H58.2302V11.655H55.4582V13.7947H58.5317V14.625H54.5908V7.875H58.5317V8.70412Z",
    fill: "#F4FAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1889 14.625H61.3215V8.70412H59.436V7.875H64.0744V8.70412H62.1889V14.625Z",
    fill: "#F4FAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4302 14.625V7.875H68.2976V14.625H67.4302Z",
    fill: "#F4FAFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1442 14.625H71.2768V8.70412H69.3913V7.875H74.0297V8.70412H72.1442V14.625Z",
    fill: "#F4FAFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.81 13.7531C82.1463 14.4349 81.3217 14.7757 80.335 14.7757C79.3484 14.7757 78.5238 14.4349 77.8612 13.7531C77.1974 13.0714 76.8667 12.2366 76.8667 11.25C76.8667 10.2634 77.1974 9.42861 77.8612 8.74686C78.5238 8.06511 79.3484 7.72311 80.335 7.72311C81.316 7.72311 82.1395 8.06624 82.8055 8.75136C83.4715 9.43649 83.8045 10.269 83.8045 11.25C83.8045 12.2366 83.4727 13.0714 82.81 13.7531ZM78.5013 13.1872C79.0008 13.6935 79.6117 13.9455 80.335 13.9455C81.0584 13.9455 81.6704 13.6924 82.1688 13.1872C82.6683 12.681 82.9192 12.0352 82.9192 11.25C82.9192 10.4647 82.6683 9.81899 82.1688 9.31274C81.6704 8.80649 81.0584 8.55449 80.335 8.55449C79.6117 8.55449 79.0008 8.80761 78.5013 9.31274C78.0029 9.81899 77.752 10.4647 77.752 11.25C77.752 12.0352 78.0029 12.681 78.5013 13.1872Z",
    fill: "#F4FAFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0218 14.625V7.875H86.0771L89.3576 13.1254H89.3947L89.3576 11.8249V7.875H90.2249V14.625H89.3193L85.8869 9.11925H85.8498L85.8869 10.4197V14.625H85.0218Z",
    fill: "#F4FAFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3453 11.5233C53.3453 12.4661 53.0663 13.2164 52.5072 13.7767C51.8727 14.4427 51.0447 14.7757 50.0277 14.7757C49.0534 14.7757 48.2243 14.4382 47.5437 13.7632C46.8619 13.0871 46.5211 12.2501 46.5211 11.2511C46.5211 10.2509 46.8619 9.41394 47.5437 8.73894C48.2243 8.06281 49.0534 7.72531 50.0277 7.72531C50.5114 7.72531 50.9738 7.81981 51.4126 8.00769C51.8524 8.19669 52.2046 8.44756 52.4678 8.76144L51.8749 9.35544C51.4283 8.82106 50.8129 8.55444 50.0266 8.55444C49.3156 8.55444 48.7013 8.80419 48.1827 9.30369C47.6641 9.80319 47.4053 10.4523 47.4053 11.2499C47.4053 12.0476 47.6641 12.6967 48.1827 13.1962C48.7013 13.6957 49.3156 13.9454 50.0266 13.9454C50.7803 13.9454 51.4092 13.6946 51.9121 13.1917C52.2383 12.8643 52.4273 12.4087 52.4779 11.8248H50.0266V11.0137H53.2969C53.3307 11.1903 53.3453 11.3602 53.3453 11.5233Z",
    stroke: "#F4FAFF",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5317 8.70412H55.4582V10.8439H58.2302V11.655H55.4582V13.7947H58.5317V14.625H54.5908V7.875H58.5317V8.70412Z",
    stroke: "#F4FAFF",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1889 14.625H61.3215V8.70412H59.436V7.875H64.0744V8.70412H62.1889V14.625Z",
    stroke: "#F4FAFF",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4302 14.625V7.875H68.2976V14.625H67.4302Z",
    stroke: "#F4FAFF",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1442 14.625H71.2768V8.70412H69.3913V7.875H74.0297V8.70412H72.1442V14.625Z",
    stroke: "#F4FAFF",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M82.81 13.7531C82.1463 14.4349 81.3217 14.7757 80.335 14.7757C79.3484 14.7757 78.5238 14.4349 77.8612 13.7531C77.1974 13.0714 76.8667 12.2366 76.8667 11.25C76.8667 10.2634 77.1974 9.42861 77.8612 8.74686C78.5238 8.06511 79.3484 7.72311 80.335 7.72311C81.316 7.72311 82.1395 8.06624 82.8055 8.75136C83.4715 9.43649 83.8045 10.269 83.8045 11.25C83.8045 12.2366 83.4727 13.0714 82.81 13.7531ZM78.5013 13.1872C79.0008 13.6935 79.6117 13.9455 80.335 13.9455C81.0584 13.9455 81.6704 13.6924 82.1688 13.1872C82.6683 12.681 82.9192 12.0352 82.9192 11.25C82.9192 10.4647 82.6683 9.81899 82.1688 9.31274C81.6704 8.80649 81.0584 8.55449 80.335 8.55449C79.6117 8.55449 79.0008 8.80761 78.5013 9.31274C78.0029 9.81899 77.752 10.4647 77.752 11.25C77.752 12.0352 78.0029 12.681 78.5013 13.1872Z",
    stroke: "#F4FAFF",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0218 14.625V7.875H86.0771L89.3576 13.1254H89.3947L89.3576 11.8249V7.875H90.2249V14.625H89.3193L85.8869 9.11925H85.8498L85.8869 10.4197V14.625H85.0218Z",
    stroke: "#F4FAFF",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_2557_98470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7405 8.4801C11.4132 8.8266 11.2197 9.36436 11.2197 10.0607V34.9412C11.2197 35.6387 11.4132 36.1754 11.7405 36.5219L11.8238 36.6029L25.7614 22.6652V22.501V22.3367L11.8238 8.39798L11.7405 8.4801Z",
    fill: "url(#paint0_linear_2557_98470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4065 27.3126L25.7614 22.6652V22.501V22.3367L30.4077 17.6905L30.5123 17.7501L36.0169 20.8776C37.5885 21.7709 37.5885 23.2322 36.0169 24.1266L30.5123 27.2541L30.4065 27.3126Z",
    fill: "url(#paint1_linear_2557_98470)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2557_98470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5123 27.2531L25.7603 22.5011L11.7405 36.522C12.258 37.071 13.1142 37.1385 14.0783 36.5918L30.5123 27.2531Z",
    fill: "url(#paint2_linear_2557_98470)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.5123 17.7491L14.0783 8.41159C13.1142 7.86372 12.258 7.93234 11.7405 8.48134L25.7614 22.5022L30.5123 17.7491Z",
    fill: "url(#paint3_linear_2557_98470)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_2557_98470",
    x: 11.2197,
    y: 8.03351,
    width: 25.976,
    height: 28.9359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.16875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2557_98470"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.16875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2557_98470",
    result: "effect2_innerShadow_2557_98470"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2557_98470",
    x: 11.7405,
    y: 22.5011,
    width: 18.7717,
    height: 14.4683,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.16875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2557_98470"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2557_98470",
    x1: 24.5259,
    y1: 9.79748,
    x2: 5.64619,
    y2: 28.6772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2557_98470",
    x1: 38.0627,
    y1: 22.501,
    x2: 10.8423,
    y2: 22.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2557_98470",
    x1: 27.9317,
    y1: 25.0818,
    x2: 2.32834,
    y2: 50.6851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2557_98470",
    x1: 8.20961,
    y1: 0.198869,
    x2: 19.6422,
    y2: 11.6315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.4bf4e1e965ff7f4bf0109eac4517c15f.svg";
export { ForwardRef as ReactComponent };